// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"137":"6bb0b3f1","202":"86a6b4cc","303":"d4d0e6b9","407":"739bcdff"}[chunkId] + ".js";
};